import { Button } from "@mui/material";
import { Grid, Paper, TextareaAutosize, TextField } from "@mui/material";
import { useCallback, useContext, useState, useRef } from "react";
import { Validation } from "../../../types/validation.types";
import { trackPromise } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import { AuthContext, ThemeContext } from "../../../contexts";
import { ContactDetails } from "../../../types/contactUs.types";
import { api } from "../../../utils/api";
import { CustomInput } from "../../shared/CustomInput";
import Contact from "../FAQs/contact/Contact";

import "./contactUs.css";
import CustomHelperTextComponent from "../../shared/customHelperTextComponent/CustomHelperTextComponent";

const ContactUs = (): JSX.Element => {
	const { member } = useContext(AuthContext);
	const GroupNumber = member?.group_number;
	const [contactDetails, setContactDetails] = useState<ContactDetails>({
		name: "",
		email: "",
		subject: "",
		description: ""
	});
	const [validation, setValidation] = useState<Validation>({
		contactDetails: {},
		status: "invalid"
	});
	const { theme } = useContext(ThemeContext);
	const _validation = useRef<Validation>();
	const history = useHistory();

	const handleValidation = useCallback(() => {
		const { name, email, subject } = contactDetails;
		_validation.current = {
			...validation,
			contactDetails: {},
			status: "invalid"
		};
		let flag = true;
		if (name.length === 0 || name === "") {
			_validation.current.contactDetails["name"] = "Name is required field";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (email.length === 0 || email === "") {
			_validation.current.contactDetails["email"] = "Email is required";
			_validation.current["status"] = "invalid";
			flag = false;
		}
		if (subject.length === 0 || subject === "") {
			_validation.current.contactDetails["subject"] = "Subject is required";
			_validation.current.status = "invalid";
			flag = false;
		}
		if (flag === true) _validation.current.status = "valid";
		else {
			_validation.current["status"] = "invalid";
			alert("Please, fill all required fields!");
		}
		setValidation(Object.assign({}, _validation.current));
		return _validation.current["status"];
	}, [contactDetails, validation]);

	const handleContactDetailsChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
			const { name, value } = event.target;
			setContactDetails(Object.assign({}, contactDetails, { [name]: value }));
		},
		[contactDetails]
	);

	const handleContactUsClick = useCallback(async () => {
		const validation = handleValidation();
		if (validation === "valid") {
			const response = await trackPromise(api.contactUs.sendContactUsEmail(contactDetails));
			if (response) {
				alert("Successfully sent your query");
				history.push("/");
			}
		} else {
			alert("Invalid");
			return;
		}
		// const response = await trackPromise(api.contactUs.sendContactUsEmail(contactDetails));
		// if (response) {
		// 	alert("Successfully sent your query");
		// 	history.push("/");
		// }
	}, [contactDetails, handleValidation, history]);

	return (
		<div className="contact-us">
			<div className="header">Contact Us </div>
			<div className="theme-border-radius contact-us-paper-form-container">
				<Grid container columnSpacing={2} justifyContent="center">
					<Grid item xl={5} lg={5} md={5}>
						<Contact groupNumber={GroupNumber} />
					</Grid>
					{/* <Grid item xl={7} lg={7} md={7}>
						<div className="contact-outer-container">
							<Paper className="theme-border-radius contact-us-container">
								<Grid container columnSpacing={4} rowSpacing={4}>
									<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
										<div className="details-form-row">
											<div className="details-form-label  required">Your Name</div>
											<CustomInput onChange={handleContactDetailsChange} name="name" />
											{validation && validation.contactDetails["name"] ? (
												<CustomHelperTextComponent
													errorText={validation.contactDetails["name"]}
												/>
											) : null}
										</div>
									</Grid>
									<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
										<div className="details-form-row">
											<div className="details-form-label  required">Your Email</div>
											<CustomInput onChange={handleContactDetailsChange} name="email" />
											{validation && validation.contactDetails["email"] ? (
												<CustomHelperTextComponent
													errorText={validation.contactDetails["email"]}
												/>
											) : null}
										</div>
									</Grid>
									<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
										<div className="details-form-row">
											<div className="details-form-label  required">Subject</div>
											<CustomInput onChange={handleContactDetailsChange} name="subject" />
											{validation && validation.contactDetails["subject"] ? (
												<CustomHelperTextComponent
													errorText={validation.contactDetails["subject"]}
												/>
											) : null}
										</div>
									</Grid>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<div className="details-form-row">
											<div className="details-form-label">Description</div>
											<TextareaAutosize
												minRows={6}
												maxRows={6}
												style={{ width: "100%" }}
												className="description"
												onChange={handleContactDetailsChange}
												name="description"
											/>
										</div>
									</Grid>
								</Grid>
								<div style={{ textAlign: "center" }}>
									<div className="button-container">
										<Button
											className="plan-action-button contact-us-button"
											style={{
												backgroundColor: theme.button.background_color,
												color: theme.button.color
											}}
											variant="contained"
											onClick={handleContactUsClick}
										>
											Submit
										</Button>
									</div>
								</div>
							</Paper>
						</div>
					</Grid> */}
				</Grid>
			</div>
		</div>
	);
};

export default ContactUs;
